import { http } from '@/lib/http';

/** Light per-tier summary returned on the quote LIST. */
export interface DeliveryQuoteOptionSummary {
  tier: string;
  name: string;
  charge: number;
  expectedDeliveryDate: string | null;
  etaDays: number | null;
  courierName: string | null;
  isLive: boolean;
}

export interface DeliveryQuoteRow {
  id: string;
  createdAt: string;
  deliveryPincode: string | null;
  country: string | null;
  weightGrams: number | null;
  currency: string;
  servedFromCache: boolean;
  /** Set when the quote was accepted into an order. */
  salesOrderId: string | null;
  acceptedOptionId: string | null;
  options: DeliveryQuoteOptionSummary[];
}

export interface DeliveryQuoteListResult {
  rows: DeliveryQuoteRow[];
  page: number;
  pageSize: number;
  total: number;
}

/** One courier the policy considered — the audit behind the chosen option. */
export interface DeliveryQuoteShortlistEntry {
  partnerId?: string;
  courierId?: string;
  courierName?: string;
  rate?: number;
  etd?: string;
  etaDays?: number;
  rating?: number;
  eligible: boolean;
  dropReason?: string;
}

export interface DeliveryQuoteOptionDetail {
  optionId: string;
  code: string;
  name: string;
  charge: number;
  currency: string;
  etaDays: number | null;
  expectedDeliveryDate: string | null;
  isLive: boolean;
  chosen: {
    partnerId?: string;
    courierId?: string;
    courierName?: string;
    etd?: string;
    etaDays?: number;
    baseRate?: number;
  } | null;
  trace: {
    policy: string;
    maxEtaDays: number | null;
    shortlist: DeliveryQuoteShortlistEntry[];
    reason: string;
  } | null;
}

export interface DeliveryQuoteDetail {
  id: string;
  createdAt: string;
  deliveryPincode: string | null;
  deliveryZone: string | null;
  country: string | null;
  weightGrams: number | null;
  subtotal: number | null;
  currency: string;
  servedFromCache: boolean;
  salesOrderId: string | null;
  acceptedOptionId: string | null;
  options: DeliveryQuoteOptionDetail[];
}

export interface ListQuotesParams {
  from?: string;
  to?: string;
  pincode?: string;
  bound?: boolean;
  page?: number;
  pageSize?: number;
}

const BASE = '/api/v1/dispatch/delivery-quotes';

export const deliveryQuotesService = {
  list: (params: ListQuotesParams = {}) => {
    const q = new URLSearchParams();
    if (params.from) q.set('from', params.from);
    if (params.to) q.set('to', params.to);
    if (params.pincode) q.set('pincode', params.pincode);
    if (params.bound != null) q.set('bound', String(params.bound));
    if (params.page) q.set('page', String(params.page));
    if (params.pageSize) q.set('pageSize', String(params.pageSize));
    const qs = q.toString();
    return http.get<DeliveryQuoteListResult>(qs ? `${BASE}?${qs}` : BASE);
  },
  get: (id: string) => http.get<DeliveryQuoteDetail>(`${BASE}/${id}`),
};
